function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 9.75V6.75C5.25 5.925 5.925 5.25 6.75 5.25H9.75V6.75H6.75V9.75H5.25ZM5.25 14.25H6.75V17.25H9.75V18.75H6.75C5.925 18.75 5.25 18.075 5.25 17.25V14.25ZM17.25 17.25H14.25V18.75H17.25C18.075 18.75 18.75 18.075 18.75 17.25V14.25H17.25V17.25ZM14.25 5.25H17.25C18.075 5.25 18.75 5.925 18.75 6.75V9.75H17.25V6.75H14.25V5.25Z",
  fill: "white"
});

var SvgIcFullscreen = function SvgIcFullscreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFullscreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_fullscreen.38f081bf.svg";
export { ForwardRef as ReactComponent };